// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"ActionReplays_sliderContainer__1CdLk","actionReplayItem":"ActionReplays_actionReplayItem__3Us4n","actioReplayTitle":"ActionReplays_actioReplayTitle__3fYXH"};